export const URLAuthLogin = `/auth/login`;

export const URLDashToday = `/dashboard/today`;

export const URLDashPointDaily = `/dashboard/collect-points/daily`;

export const URLDashPointWeekly = `/dashboard/collect-points/weekly`;

export const URLDashDepartamentASC = `/dashboard/departments?sort=ASC`;

export const URLDashDepartamentDESC = `/dashboard/departments?sort=DESC`;

export const URLGenericTypes = `/generic-types`;

export const URLVehicles = `/vehicles`;

export const URLDashWork = `/dashboard/work`;

export const URLDashWorkVehicles = `/dashboard/work/vehicles`;
// ---------------------------- APIS ID ------------------------------------
export function URLDashWorkVehiclesId(id) {
  return `/dashboard/work/vehicles/${id}`;
}
export function URLDashIncident(id) {
  return `/incidents/GetIncidents?collectPointId=${id}`;
}
export function URLDashIncidentDoucment(id) {
  return `/incidents/GetIncidentDocument?incidentId=${id}`;
}
export function URLDashIncidentComment(id) {
  return `/incidents/GetIncidentComment/${id}`;
}
export function URLDashWorkCollect(idV, idP) {
  return `/dashboard/work/vehicles/${idV}/collect-points/${idP}`;
}

export function URLGenericTypesId(id) {
  return `/dashboard/generic-types/${id}`;
}

export const URLReportDaily = `/reports/daily`;
export const URLReportRange = `/reports/range`;
export const URLReportIncident = (dateInitial, dateFinal, id) => {
  return `/incidents/GetIncidentReport?dateFrom=${dateInitial}&dateTo=${dateFinal}&miningSiteId=${id}`;
};

export const URLIngresosClientes = `/tempyards/GetClients`;
export const URLStatus = `/tempyards/GetOutputStates`;

export function URLPatiosId(id) {
  return `/tempyards/GetWarehouses/${id}`;
}
export function URLIngresosId(Page, miningSite, warehouse, dateFrom, dateTo) {
  return `/tempyards/GetInputsPaginated/${Page}/${miningSite}/${warehouse}/${dateFrom}/${dateTo}`;
}
export function URLIngresoSpecficId(id) {
  return `/tempyards/GetInputDetail/${id}`;
}

export function URLStock(miningSite, warehouse) {
  return `/tempyards/ListStockByClientAndYard/${warehouse}/${miningSite}`;
}

export function URLSalidas(Page, miningSite, warehouse, dateFrom, dateTo) {
  return `/tempyards/GetOutputsPaginated/${Page}/${miningSite}/${warehouse}/${dateFrom}/${dateTo}`;
}

export function URLSalidaSpecficId(id) {
  return `/tempyards/GetOutputDetail/${id}`;
}

export function URLDocuments(outputId) {
  return `/tempyards/GetOutputDocuments/${outputId}`;
}

export function URLGetAccept(outputId) {
  return `/tempyards/GetOutputDetail/${outputId}`;
}

export const URLPutAccept = `/tempyards/ApprovedOutput`;

export function URLVehiculo(miningSiteId) {
  return `/tempyards/GetVehicles/${miningSiteId}`;
}
export function URLDestinity(miningSiteId) {
  return `/tempyards/ListMineDispositionsByClient/${miningSiteId}`;
}

export function URLConductor(miningSiteId) {
  return `/tempyards/GetDrivers/${miningSiteId}`;
}
